import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyC374NDCS79MiCUxHoYuePtqyJYZD3rYcs',
  authDomain: 'tektontechnology-searchngo.firebaseapp.com',
  projectId: 'tektontechnology-searchngo',
  storageBucket: 'tektontechnology-searchngo.firebasestorage.app',
  messagingSenderId: '252553223550',
  appId: '1:252553223550:web:7af88701719087bc3a672f',
  measurementId: 'G-7GSYSP0F83',
};

export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);

export const initAnalytics = () => {
  if (typeof window === 'undefined') return null;
  return isSupported()
    .then((supported) => (supported ? getAnalytics(app) : null))
    .catch(() => null);
};
